// SPDX-License-Identifier: AGPL-3.0-or-later
import asset0 from '@app/media/images/badges/special/app.svg';
import asset1 from '@app/media/images/badges/special/beta.svg';
import asset2 from '@app/media/images/badges/special/bot.svg';
import asset3 from '@app/media/images/badges/special/dark-ai.svg';
import asset4 from '@app/media/images/badges/special/discord-lootbox.svg';
import asset5 from '@app/media/images/badges/special/light-ai.svg';
import asset6 from '@app/media/images/badges/special/official.svg';
import asset7 from '@app/media/images/badges/special/original-poster.svg';
import asset8 from '@app/media/images/badges/special/server.svg';
import asset9 from '@app/media/images/badges/special/system.svg';
import asset10 from '@app/media/images/badges/special/verified-app.svg';
import asset11 from '@app/media/images/badges/special/verified-bot.svg';

export const SPECIAL_TAG_ASSETS = Object.freeze({
	'app': asset0,
	'beta': asset1,
	'bot': asset2,
	'dark-ai': asset3,
	'discord-lootbox': asset4,
	'light-ai': asset5,
	'official': asset6,
	'original-poster': asset7,
	'server': asset8,
	'system': asset9,
	'verified-app': asset10,
	'verified-bot': asset11,
});
